import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const CombinedServiceView = Loadable(
  lazy(() =>
    import("./CombineServiceUI/CombinedServiceView").then(
      ({ CombinedServiceView }) => ({
        default: CombinedServiceView,
      }),
    ),
  ),
);

const ServiceItemsList = Loadable(
  lazy(() =>
    import("./serviceItems/ServiceItemsList").then(({ ServiceItemsList }) => ({
      default: ServiceItemsList,
    })),
  ),
);

const ManageServiceItem = Loadable(
  lazy(() =>
    import("./serviceItems/ManageServiceItem").then(
      ({ ManageServiceItem }) => ({
        default: ManageServiceItem,
      }),
    ),
  ),
);

const ServiceCategoryList = Loadable(
  lazy(() =>
    import("./serviceCategory/ServiceCategoryList").then(
      ({ ServiceCategoryList }) => ({
        default: ServiceCategoryList,
      }),
    ),
  ),
);

const VariantsList = Loadable(
  lazy(() =>
    import("./Variants/VariantsList").then(({ VariantsList }) => ({
      default: VariantsList,
    })),
  ),
);

const ManageVariants = Loadable(
  lazy(() =>
    import("./Variants/ManageVariants").then(({ ManageVariants }) => ({
      default: ManageVariants,
    })),
  ),
);

export const serviceRoutes = [
  {
    path: "/service-categories",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_CATEGORY]}>
        <CombinedServiceView />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/packages",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ITEM]}>
        <ServiceItemsList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/packages/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ITEM]}>
        <ManageServiceItem />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/packages/manage/:packageId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ITEM]}>
        <ManageServiceItem />
      </AuthorizedRoute>
    ),
  },

  // {
  //   path: "/service-categories",
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_CATEGORY]}>
  //       <ServiceCategoryList />
  //     </AuthorizedRoute>
  //   ),
  // },
  {
    path: "/items",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ALIGN]}>
        <VariantsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/items/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ALIGN]}>
        <ManageVariants />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/items/manage/:itemId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SERVICE_ALIGN]}>
        <ManageVariants />
      </AuthorizedRoute>
    ),
  },
];
